import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { OrderFinance } from '@trukt/types/OrderFinance';

export type OrderFinanceUpdateRequestBodyCommodity = {
  guid: string;
  payment: string;
};

export type OrderFinanceUpdateRequestBody = {
  payment?: string;
  commodities?: OrderFinanceUpdateRequestBodyCommodity[];
};

export type OrderFinanceUpdateRequest = BaseRequest<
  void,
  OrderFinanceUpdateRequestBody,
  { orderGuid: string }
>;
export type OrderFinanceUpdateResponse = void;

export type OrderGetFinancesRequest = BaseRequest<void, void, { orderGuid: string }>;
export type OrderGetFinancesResponse = OrderFinance;

export class OrderFinanceService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getById({ routeParams }: OrderGetFinancesRequest) {
    return this.instance.get<OrderGetFinancesResponse>(`/orders/${routeParams.orderGuid}/finances`);
  }

  update({ routeParams, body }: OrderFinanceUpdateRequest) {
    return this.instance.put(`/orders/${routeParams.orderGuid}/finances`, body);
  }
}
